import AntdConfigProvider from 'antd/es/config-provider';
import { ComponentProps, useState } from 'react';
import { useMount } from 'ahooks';
import type { Locale } from 'antd/es/locale';
import dayjs from 'dayjs';
import defaultTheme from '../../theme';
import { localeMap, localeData } from '../locale/navigate';
import type { SupportLocale } from '../locale/navigate';

type Props = ComponentProps<typeof AntdConfigProvider> & DefaultLocaleType;
type DefaultLocaleType = { defaultLocale?: SupportLocale };

function ConfigProvider(props: Props) {
    const [loading, setLoading] = useState(true);

    const [locale, setLocal] = useState<Locale | undefined>((localeData as any)[props.defaultLocale || 'en_US']);

    useMount(async () => {
        const defaultLocale = props.defaultLocale || 'en_US';
        // let localeValue = {
        //     default: {},
        // };
        // try {
        //     localeValue = await import(`@/library/locale/${defaultLocale}.ts`);
        // } catch (error) {
        //     console.warn(`ef-ui: 找不到${props.defaultLocale}对应的语言，采用默认语言：en_US`);
        //     // @ts-ignore
        //     localeValue = await import(`@/library/locale/en_US.ts`);
        // }

        // setLocal(localeValue.default as any);

        dayjs.locale(localeMap[defaultLocale] || 'en');

        // setLoading(false);
    });

    // if (loading) return <></>;

    return <AntdConfigProvider theme={{ ...defaultTheme }} locale={locale} {...props} />;
}

export default ConfigProvider;
